import Vue from "vue";
import "./http";
import "./http2";

if (process.env.VUE_APP_MOCK === "true") {
  require("./mock");
}

Vue.prototype.$copy = function(value) {
  this.$copyText(`${value}`).then(
    () => {
      if (this.$route.path.includes("/mobile")) {
        this.$toast(this.$t("copy_success"));
      } else {
        this.$message({
          message: this.$t("copy_success"),
          type: "success"
        });
      }
    },
    () => {
      this.$message.error(this.$t("copy_failed"));
    }
  );
};
